import {httpClient} from "../Api";

export const createHandler = (route, method = 'POST') => (model, callbackFn) => {

    httpClient.defaults.headers.common["Authorization"] = "Bearer " + "ey2sakxhakskxnalwoeu297dhs9dsxnx9s0";
    const request = method === 'POST' ? httpClient.post : httpClient.get;
    return request(route, model)
        .then(({data}) => {

            if (callbackFn) {
                callbackFn({data: data, status: true})
            }
        })
        .catch(function (error) {

            if(callbackFn){
                callbackFn({data: error, status: false});
            }
        });
};
